import {Node} from '../../node/node.mjs';
import {TokenName} from './lexical.mjs';
import {NodeName} from './nodeName.mjs';
import {lineNumber, syntaxError, consumeHeadingContent} from './rulesUtils.mjs';

class UnitTitle {
    consume(tokenIterator, nodeIterator) {
        if (tokenIterator.token().name !== TokenName.UNIT_TITLE) return;
        const line = lineNumber(tokenIterator);
        const name = consumeHeadingContent(tokenIterator).trim();
        if (!name) throw syntaxError(line, 'Unit name is required');

        if (nodeIterator.currentParentNode.name === NodeName.UNIT) {
            nodeIterator.closeNodeAtIndex(nodeIterator.openNodes.length - 1);
        }
        nodeIterator.addOpenNode(new Node(NodeName.UNIT, name, this, nodeIterator.currentParentNode));
    }

    onEndOfMarkup(node) {
        node.close();
    }
}

export {UnitTitle};
